<px-m0210-accordion-teaser
[teasers]="content"
></px-m0210-accordion-teaser>
